export const columns = [
  {
    title: 'Changelog',
    isExternal: true,
    link: `https://changelog.zap.tech/`,
  },
  {
    title: 'Documentation',
    isExternal: true,
    link: `https://docs.zap.tech/zaponchain/`,
  },
  {
    title: 'Privacy Policy',
    isExternal: true,
    link: `https://docs.zap.tech/zaponchain/other/privacy-policy`,
  },
  {
    title: 'Terms and Conditions',
    isExternal: true,
    link: `https://docs.zap.tech/zaponchain/other/terms-and-conditions`,
  },
  {
    title: 'Careers',
    isExternal: true,
    link: `https://zap-launchpad.notion.site/Work-at-ZAP-f77964a03aee4cfe8d09161c9d493efd?pvs=4`,
  },
  {
    title: 'Roadmap',
    isExternal: false,
    link: `/roadmap`,
  },
  {
    title: 'Dextools',
    isExternal: true,
    link: `https://www.dextools.io/app/en/base/pair-explorer/0x1366e32276ceceae48c470ac2d0f645c6fcc544d?t=1729691207559`,
  }
]

export const socialLinks = [
  {
    title: 'X',
    icon: '/supported-socials/custom-icons/x-icon-footer.svg',
    link: 'https://twitter.com/zaponchain',
  },
  {
    title: 'Discord',
    icon: '/supported-socials/custom-icons/discord-icon-footer.svg',
    link: 'https://discord.gg/zaponchain',
  },
  {
    title: 'Telegram',
    icon: '/supported-socials/custom-icons/telegram-icon-footer.svg',
    link: 'https://t.me/zaponblast',
  },
]
